<template>
  <div class="diadin">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input style="width: 300px;" clearable :placeholder="$t('menu.wbddh')"
          v-model="formInline.searchValue"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="formInline.mcVersionId" filterable  :placeholder="$t('menu.VehicleModel')" clearable>
          <el-option v-for="(item, index) in cartypelist" :key="index" v-if="item.dictValue!=='9000'"
            :label="iszh == 'zh' ? item.dictLabel : item.dictLabelEn" :value="item.dictValue"></el-option>
        </el-select>
        
      
      </el-form-item>
      <el-form-item>
      
        <el-select v-model="formInline.dealerId" filterable  :placeholder="$t('menu.wbdlss')" clearable>
          <el-option v-for="(item, index) in mationaa" :key="index" 
            :label="item.dealerName" :value="item.id"></el-option>
        </el-select>
        
      </el-form-item>
      <!-- <el-form-item>
        <el-select v-model="formInline.status" :placeholder="$t('menu.State')" clearable>
          <el-option :label="this.$t('menu.All')" value=""></el-option>
          <el-option :label="$t('menu.Unregistered')" value="Unregistered"></el-option>
          <el-option :label="$t('menu.Registered')" value="Registered"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-date-picker v-model="formInline.salesDate" type="date" value-format="yyyy-MM-dd" :placeholder="$t('menu.wbdsj')">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
      
        <el-button type="primary" @click="onSubmit">{{ $t('menu.search') }}</el-button>
        <el-button @click="reset">{{ $t('menu.Reset') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="bonntbot">
      <el-button type="primary" @click="batchRegistration">{{ $t('menu.wbdtj') }}</el-button>
      <!-- <el-button type="text">{{ $t('menu.Export') }}</el-button> -->
    </div>
    <el-table empty-text=" " :data="mation" style="width: 100%" stripe border highlight-current-row>
       <el-table-column prop="orderNumber"  :label="$t('menu.wbddh')" min-width="140"></el-table-column>
      <el-table-column prop="mcVersionId" :formatter="filterCarModels" :label="$t('menu.Vehicle')" min-width="140">
        <template slot-scope="scope">
          {{ motosale(scope.row.mcSeriesModel) }}
        </template>    
      </el-table-column>
      <el-table-column prop="vin" :label="$t('menu.FrameNumber')" min-width="140"> </el-table-column>
       <el-table-column prop="mileage"  :label="$t('menu.wbdlc')" min-width="120"></el-table-column>
         <el-table-column prop="dealerName"  :label="$t('menu.wbdlss')" min-width="120"></el-table-column>
           <el-table-column prop="createTime" :formatter="formatters" :label="$t('menu.wbdsj')" min-width="120"></el-table-column>
      <el-table-column prop="status" :label="$t('menu.State')" min-width="100">
        <template slot-scope="scope">
          {{ teck(scope.row.status) }}
        </template>
      </el-table-column>
    
      
      <el-table-column :label="$t('menu.Operation')" min-width="80">
        <template slot-scope="scope">
          
          <el-button type="text" size="mini" @click="handleEdit(2, scope.row)">{{ $t('menu.Details')
            }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]" :page-size="pigesiza" layout="total,sizes, prev, pager, next" :total="totale">
      </el-pagination>
    </div>

    <!-- 导入 -->
    <el-dialog :title="$t('menu.Import')" :visible.sync="centerDialogVisible" width="30%">
      <div v-if="importType == 0">
        <div class="importTop" v-if="importType == 0">
          {{$t('menu.Importtemplate')}}<el-button type="text" style="margin-left: 30px;" @click="templateDowload">{{$t('menu.Download')}}</el-button>
        </div>
        <div class="importCente">
          <el-upload action="" :http-request="httpRequest" :show-file-list="false" :file-list="fileList">
            <el-button plain style="width: 180px;">{{$t('menu.Import')}}</el-button>
          </el-upload>
        </div>
      </div>

      <div v-if="importType == 1">
        <div class="importCente">
          <div>
            检查到： 78个配件
          </div>
        </div>
        <div class="importBottom">
          <el-button type="primary" @click="determine1">确定注册</el-button>
        </div>
      </div>

      <div v-if="importType == 2">
        <div class="importCente2">
          <div class="errText">{{ errorMsg }}</div>
          <el-button type="text" style="margin-top: 30px;" v-if="importType == 2" @click="importagain">重新导入</el-button>
        </div>
        <div class="importBottom">
          <el-button type="primary" @click="determine2">{{ $t('menu.Confirm') }}</el-button>
        </div>
      </div>




    </el-dialog>
  </div>
</template>
  
  <script>
import { getInfo,moOfDealerlist,listMcSeriesModels,templateDowload,importFiles,querytype,retailerlist } from "../../api/api";

export default {
  data () {
    return {
      userId: null,
      currentPage3: 1,
      pigesiza:10,
      totale: 0,
      mation: [], //列表
      cartypelist: [],
      formInline: {
        searchValue: "",
        mcVersionId: "",
        status: "",
        salesDate: "",
        dealerId:''
      },
      downUrl:'',
      mationaa:[],
      importType:0,
      iszh:sessionStorage.getItem('i18n'),
      centerDialogVisible:false,
      errorMsg:'',
      fileList:[],
    };
  },
  created () {
    // this.listMcSeriesModel()
    this.downloadUrl()
    this.getQuerytype()
  },
  mounted () {
    this.getInfoa()
    this.lsh()
  },
  methods: {
    async lsh () {
      let param = new URLSearchParams();

      const { data: res } = await retailerlist(
        param,
        1,
        500
      );
      console.log(res);

      this.mationaa = res.rows;
     
    },

    async downloadUrl () {
      let param = new URLSearchParams();
      const { data: res } = await querytype(param, 't_excel_template');
      res.data.forEach(e=>{
        if(e.dictLabel=="批量销售注册模版"){
          this.downUrl = e.dictValue
        }
      })
   
    },
    
    //获取人员信息
    getInfoa () {
      getInfo().then(r => {
        if (r.data.code == 200) {
          this.userId = r.data.user.userId
          this.getList()
        }
      })
    },
    //查询车辆列表
    getList () {
      let a = ''
      a = this.formInline.salesDate != '' ? this.formInline.salesDate + ' 00:00:00' : this.formInline.salesDate
      let params = 'searchValue=' + this.formInline.searchValue +'&dealerId=' + this.formInline.dealerId+ '&pageNum=' + this.currentPage3 + '&pageSize='+this.pigesiza+'&mcSeriesModel=' + this.formInline.mcVersionId + '&status='
        + this.formInline.status + '&salesDate=' + a+'&isAsc=desc&orderByColumn=createTime'
      moOfDealerlist(params).then(res => {
        if (res.data.code == 200) {
          this.mation = res.data.rows
          this.totale = res.data.total
        }
      })
    },
    filterCarModels (row) {
      if (this.cartypelist.some(e => e.id == row.mcVersionId)) {
        return this.cartypelist.filter(e => e.id == row.mcVersionId)[0].seriesModel
      } else {
        return row.mcVersionId
      }
    },
    //获取车型
    async listMcSeriesModel () {
      let param = new URLSearchParams();
      const { data: res } = await listMcSeriesModels(param);
      this.cartypelist = res.data;
    },
    teck (e) {
      if (e == '-1') {
        return '已取消'
      } 
      if (e == '0') {
        return '待服务'
      } 
      if (e == '1') {
        return this.$t('menu.wbdyfw')
      } 
     
    },
    motosale (e) {
      let a = this.cartypelist
      let b =''
      if(e!==null){
        a.forEach(z=>{
          if(z.dictValue == e){

            b= this.iszh=='zh'?z.dictLabel:z.dictLabelEn
          }
        })
      }
      return b
    },
   httpRequest ( item) {
      var formData = new FormData()
      formData.append('file', item.file)
      importFiles(formData).then( async res => {
        console.log(res,123);
        let jsonText =null
        let texta =null
       if(res.data.type=='application/json'){
        console.log(res,123);
        texta= await res.data.text()
        jsonText=  await JSON.parse(texta)
        console.log(res,123);
      }
        
       
          if(jsonText!==null&&jsonText.code==500){
          this.importType = 2
          this.errorMsg = jsonText.msg
          this.$message.error(jsonText.msg)
        }else{
          console.log(222);
          
         // 创建一个URL对象，将Blob对象包装成一个临时的可访问URL
         const url = window.URL.createObjectURL(new Blob([res.data]));
        // 创建一个<a>元素，用于模拟点击下载文件
        const link = document.createElement('a');
        link.href = url;
        // 设置下载文件的名称
        link.setAttribute('download', '车辆导入结果.xlsx');
        // 将<a>元素添加到文档中
        document.body.appendChild(link);
        // 模拟点击下载
        link.click();
        // 移除<a>元素
        // link.remove();
        // 释放创建的URL对象，避免内存泄漏
        window.URL.revokeObjectURL(url);
       
          this.$message.success('Success')
          this.centerDialogVisible = false
          this.getList()
        }
      }).catch((err) => {
        this.$message.error(res.data.msg)
      })
    },
    importagain(){
      this.importType = 0 
      this.errorMsg = ''
    },
    handleEdit (index, row) {
      let a = sessionStorage.getItem('name')
      let b = sessionStorage.getItem('namef')
      sessionStorage.setItem('namefac1',a )
      sessionStorage.setItem('namefac2',b )
      let cc  =sessionStorage.getItem('i18n')
      if (cc !== 'zh') {
        sessionStorage.setItem('name', 'Details')
        sessionStorage.setItem('namef', '订单详情')

      } else {
        sessionStorage.setItem('name', '订单详情')
        sessionStorage.setItem('namef', 'Details')
      }
      this.$router.push({
        path: "/Maintenancecontent",
        query: {
          id: row.id
        },
      });
    },
    //搜索
    onSubmit () {
      this.getList()
    },
    //创建
    batchRegistration(){
       this.$router.push({
        path: "/Maintenanceup"
      });
    },
    reset () {
      this.formInline = {
        searchValue: "",
        mcVersionId: "",
        status: "",
        salesDate: "",
        dealerId:'',
      }
      this.getList()
    },
    formatters(row, column, cellValue, index){

      if(cellValue != null && cellValue !=''){
        return cellValue.split(' ')[0]
      } else {
        return cellValue
      }
    },
    getQuerytype () {
      const params = new URLSearchParams()
      querytype( params, 't_mc_series_model').then(r => {
        console.log(r);
        this.cartypelist = r.data.data;
        // if (r.data.code == 200) {
        //   r.data.data.forEach(i => {
        //     if (this.iszh !== 'zh') {
        //       i.dictLabel = i.dictLabelEn
        //     }
        //     this.titleList.push(i)
        //   })
        // }
      })
    },
    handleSizeChange (val) {
      this.pigesiza=val
       this.getList()
    },
    handleCurrentChange (val) {
      this.currentPage3 = val
      this.getList()
    },
    templateDowload(){
    //  this.downUrl //这是模板地址
 
      let link = document.createElement("a");
      //创建一个a标签
      link.style.display = "none";
      //将a标签隐藏
      link.href = this.downUrl;
      //给a标签添加下载链接  "域名+接口"  safe是一个动态的域名  后面的接口替换成你自己的下载接口
      link.setAttribute("download",  '批量注册模板.xlsx');

      // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
      document.body.appendChild(link);
      //将上面创建的a标签加入到body的尾部
      link.click();
    },
  },
};
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
}

.bonntbot {
  padding-bottom: 20px;
  border-bottom: 1px solid #d7d7d7;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

.xz-box {
  width: 400px;
  margin: 0 auto;
}

.importTop {
  height: 80px;
  line-height: 80px
}

.importCente {
  width: 100%;
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.importCente2 {
  .errText {
    color: red;
  }
}

.importBottom {
  width: 100%;
  margin-top: 20px;

  :deep(.el-button) {
    width: 100%;
  }
}
</style>